export enum OwnershipType {
  Owned,
  Leased,
  Financed,
  Rented
}

export enum OwnershipLabelType {
  Owned = 'Owned',
  Leased = 'Leased',
  Financed = 'Financed',
  Rented = 'Rented'
}
